import { render, staticRenderFns } from "./g-form.vue?vue&type=template&id=e0b11f8a&"
import script from "./g-form.vue?vue&type=script&lang=js&"
export * from "./g-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports